import { api, tr } from './shared';

export function getRkeeperSections(lang) {
  return [
    {
      id: 'rkeeper-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'R-Keeper — обзор', 'R-Keeper — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Интеграция R-Keeper позволяет POS-системе ресторана обращаться к программе лояльности Loyalclub при каждой транзакции на кассе. Реализован протокол FarCards — стандартный XML-интерфейс R-Keeper для внешних систем лояльности. Дополнительно доступен современный JSON REST API для прямых запросов.',
            'The R-Keeper integration allows restaurant POS systems to query the Loyalclub loyalty program at every checkout transaction. The FarCards protocol — R-Keeper\'s standard XML interface for external loyalty systems — is implemented. A modern JSON REST API is also available for direct requests.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что умеет интеграция', 'Integration capabilities'),
          items: [
            tr(lang, 'Получить данные карты и баланс по номеру карты', 'Get card data and balance by card number'),
            tr(lang, 'Начислить кэшбэк (accrual) за покупку', 'Accrue cashback for a purchase'),
            tr(lang, 'Списать баллы как оплату (payment)', 'Deduct points as payment'),
            tr(lang, 'Применить скидку по дисконтной карте (discount)', 'Apply discount card (discount)'),
            tr(lang, 'Отменить любую из перечисленных операций', 'Reverse any of the above operations'),
            tr(lang, 'Найти карту по email (FarCards: findemail)', 'Find a card by email (FarCards: findemail)'),
            tr(lang, 'Поддержка нескольких ресторанов на одном API-ключе через restaurant_code', 'Multiple restaurants on one API key via restaurant_code'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Base URL', 'Base URL'),
          items: [`${api.host}/rkeeper`],
        },
        {
          type: 'list',
          title: tr(lang, 'Поддерживаемые типы карт', 'Supported card types'),
          items: ['cashback', 'discount', 'stamp', 'subscription', 'certificate'],
        },
      ],
    },
    {
      id: 'rkeeper-auth',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navOrder: 5,
      navLabel: tr(lang, 'Аутентификация', 'Authentication'),
      title: tr(lang, 'R-Keeper — аутентификация', 'R-Keeper — authentication'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'R-Keeper POS передаёт API-ключ через заголовок или Basic Auth. Ключ выдаётся при создании интеграции. Management-эндпоинты (создание, обновление) требуют обычной авторизации loyalclub.',
            'R-Keeper POS provides the API key via a header or Basic Auth. The key is issued when the integration is created. Management endpoints (create, update) require standard loyalclub authorization.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Способ 1 — заголовок', 'Method 1 — header'),
          items: ['X-API-Key: rk_<API_KEY>'],
        },
        {
          type: 'list',
          title: tr(lang, 'Способ 2 — Basic Auth (R-Keeper использует этот способ)', 'Method 2 — Basic Auth (used by R-Keeper)'),
          items: [
            tr(lang, 'Authorization: Basic base64(:<API_KEY>)', 'Authorization: Basic base64(:<API_KEY>)'),
            tr(lang, 'Authorization: Basic base64(<API_KEY>:)', 'Authorization: Basic base64(<API_KEY>:)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Management API (создание / обновление интеграции)', 'Management API (create / update integration)'),
          items: ['Authorization: Bearer <USER_TOKEN>'],
        },
      ],
    },
    {
      id: 'rkeeper-setup',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Настройка', 'Setup'),
      title: tr(lang, 'R-Keeper — настройка', 'R-Keeper — setup'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Порядок подключения', 'Connection steps'),
          items: [
            tr(lang, '1. Создайте интеграцию через POST /rkeeper/integration/organization/{org_id} — получите api_key и список FarCards URL', '1. Create the integration via POST /rkeeper/integration/organization/{org_id} — you will receive an api_key and a list of FarCards URLs'),
            tr(lang, '2. Сохраните api_key — он показывается один раз (хранится в виде хеша)', '2. Save the api_key — it is shown only once (stored as a hash)'),
            tr(lang, '3. В настройках R-Keeper укажите адреса FarCards-эндпоинтов (см. health-check)', '3. In R-Keeper settings enter the FarCards endpoint URLs (see health-check)'),
            tr(lang, '4. Настройте аутентификацию R-Keeper: Basic Auth с api_key в поле пароля', '4. Configure R-Keeper authentication: Basic Auth with the api_key in the password field'),
            tr(lang, '5. При наличии нескольких ресторанов укажите restaurant_code для каждого', '5. For multiple restaurants set a restaurant_code for each'),
            tr(lang, '6. Проверьте соединение через GET /rkeeper/integration/organization/{org_id}/health', '6. Verify the connection via GET /rkeeper/integration/organization/{org_id}/health'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Поля при создании', 'Creation fields'),
          items: [
            tr(lang, 'card_id (string, обязательно) — UUID карты лояльности', 'card_id (string, required) — loyalty card UUID'),
            tr(lang, 'restaurant_code (string, опционально) — код ресторана для фильтрации запросов', 'restaurant_code (string, optional) — restaurant code for request filtering'),
            tr(lang, 'settings (object, опционально) — дополнительные настройки', 'settings (object, optional) — additional settings'),
          ],
        },
      ],
    },
    {
      id: 'rkeeper-integration-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Создать интеграцию', 'Create integration'),
      title: 'POST /rkeeper/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт интеграцию с R-Keeper. API-ключ (api_key) возвращается один раз — сохраните его. В БД хранится только хеш.',
            'Creates an R-Keeper integration. The API key (api_key) is returned once — save it. Only its hash is stored in the database.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно, возвращает api_key и webhook_url', '200 — success, returns api_key and webhook_url'),
            tr(lang, '401 — не авторизован', '401 — unauthorized'),
            tr(lang, '403 — нет доступа', '403 — forbidden'),
            tr(lang, '404 — карта не найдена', '404 — card not found'),
            tr(lang, '409 — интеграция для карты уже существует', '409 — integration for this card already exists'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'rk-int-create-body',
          value: `{\n  "card_id": "<CARD_UUID>",\n  "restaurant_code": "REST1",\n  "settings": {}\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-int-create',
          value: `curl -X POST "${api.host}/rkeeper/integration/organization/<ORG_UUID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{\n    "card_id": "<CARD_UUID>",\n    "restaurant_code": "REST1"\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'rk-int-create-resp',
          value: `{\n  "id": 1,\n  "organization_id": 42,\n  "card_id": 7,\n  "api_key": "rk_abc123...",\n  "webhook_url": "${api.host}/rkeeper/licenseinfo",\n  "is_active": true,\n  "restaurant_code": "REST1"\n}`,
        },
      ],
    },
    {
      id: 'rkeeper-integration-get',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Получить интеграцию', 'Get integration'),
      title: 'GET /rkeeper/integration/organization/{org_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает настройки интеграции для карты (без api_key).', 'Returns integration settings for a card (without api_key).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-int-get',
          value: `curl -X GET "${api.host}/rkeeper/integration/organization/<ORG_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'rkeeper-integration-update',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить интеграцию', 'Update integration'),
      title: 'PUT /rkeeper/integration/organization/{org_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Обновляет настройки интеграции: is_active, restaurant_code, settings.', 'Updates integration settings: is_active, restaurant_code, settings.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'rk-int-update-body',
          value: `{\n  "is_active": true,\n  "restaurant_code": "REST2",\n  "settings": {}\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-int-update',
          value: `curl -X PUT "${api.host}/rkeeper/integration/organization/<ORG_UUID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"is_active": true, "restaurant_code": "REST2"}'`,
        },
      ],
    },
    {
      id: 'rkeeper-regen-key',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 40,
      navLabel: tr(lang, 'Перегенерировать ключ', 'Regenerate key'),
      title: 'POST /rkeeper/integration/organization/{org_id}/regenerate-key',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Генерирует новый api_key. Все предыдущие ключи немедленно аннулируются. Новый ключ показывается один раз.',
            'Generates a new api_key. All previous keys are immediately invalidated. The new key is shown only once.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — новый api_key в ответе', '200 — new api_key in response'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-regen-key',
          value: `curl -X POST "${api.host}/rkeeper/integration/organization/<ORG_UUID>/regenerate-key" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'rkeeper-health',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 50,
      navLabel: tr(lang, 'Health-check / FarCards URLs', 'Health-check / FarCards URLs'),
      title: 'GET /rkeeper/integration/organization/{org_id}/health',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Возвращает статус интеграции и полный список FarCards-эндпоинтов, которые нужно прописать в R-Keeper.',
            'Returns the integration status and the full list of FarCards endpoints to be configured in R-Keeper.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'rk-health-resp',
          value: `{\n  "integration_id": 1,\n  "is_active": true,\n  "card_type": "cashback",\n  "restaurant_code": "REST1",\n  "api_mode": "farcards-http+xml",\n  "auth_modes": ["X-API-Key", "BasicAuth"],\n  "endpoints": {\n    "getcardinfoex":   "${api.host}/rkeeper/getcardinfoex",\n    "transactionsex":  "${api.host}/rkeeper/transactionsex",\n    "findemail":       "${api.host}/rkeeper/findemail",\n    "getcardimageex":  "${api.host}/rkeeper/getcardimageex",\n    "licenseinfo":     "${api.host}/rkeeper/licenseinfo"\n  }\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-health',
          value: `curl -X GET "${api.host}/rkeeper/integration/organization/<ORG_UUID>/health" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'rkeeper-test-card',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 55,
      navLabel: tr(lang, 'Test-card', 'Test-card'),
      title: 'POST /rkeeper/integration/organization/{org_id}/test-card',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Быстрая проверка: ищет карту клиента по номеру в организации и возвращает тот же payload, что JSON API card/info (без вызова кассы).',
            'Quick check: looks up a client card by number in the organization and returns the same payload as JSON API card/info (no POS call).',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-test-card',
          value: `curl -X POST "${api.host}/rkeeper/integration/organization/<ORG_UUID>/test-card" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"card_number": "000042"}'`,
        },
      ],
    },
    {
      id: 'rkeeper-card-info',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'JSON API', 'JSON API'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Информация о карте', 'Card info'),
      title: 'POST /rkeeper/card/info',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Возвращает данные карты и текущий баланс по номеру. Аутентификация: X-API-Key или Basic Auth.',
            'Returns card data and current balance by card number. Authentication: X-API-Key or Basic Auth.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['X-API-Key: rk_<API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            tr(lang, 'card_number (string, обязательно) — номер карты клиента', 'card_number (string, required) — customer card number'),
            tr(lang, 'station_id (string, опционально) — ID кассы/станции', 'station_id (string, optional) — POS station ID'),
          ],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — неверный API-ключ', '401 — invalid API key'), tr(lang, '404 — карта не найдена', '404 — card not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-card-info',
          value: `curl -X POST "${api.host}/rkeeper/card/info" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: rk_<API_KEY>" \\\n  -d '{"card_number": "000042", "station_id": "POS1"}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (успех)', 'Example response (success)'),
          key: 'rk-card-info-resp',
          value: `{\n  "success": true,\n  "card_number": "000042",\n  "client_name": "Иван Иванов",\n  "phone": "+79001234567",\n  "balance": 500,\n  "cashback_percent": 5,\n  "discount_percent": 0,\n  "status": "gold",\n  "stamps": 3,\n  "stamps_to_reward": 7,\n  "available_rewards": 1,\n  "card_type": "cashback"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 401 — неверный ключ', '401 error — invalid key'),
          key: 'rk-card-info-err-401',
          value: `HTTP/1.1 401 Unauthorized\n\n{\n  "detail": "Invalid API key"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 404 — карта не найдена', '404 error — card not found'),
          key: 'rk-card-info-err-404',
          value: `HTTP/1.1 404 Not Found\n\n{\n  "detail": "Card not found: 000042"\n}`,
        },
      ],
    },
    {
      id: 'rkeeper-transaction',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'JSON API', 'JSON API'),
      navSubgroupOrder: 20,
      navOrder: 20,
      navLabel: tr(lang, 'Транзакция', 'Transaction'),
      title: 'POST /rkeeper/transaction',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Проводит транзакцию лояльности. Идемпотентна по полю external_id — повторный запрос с тем же external_id вернёт {duplicate: true} без повторного применения.',
            'Processes a loyalty transaction. Idempotent by external_id — a repeat request with the same external_id returns {duplicate: true} without re-applying.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['X-API-Key: rk_<API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            tr(lang, 'card_number (string, обязательно) — номер карты', 'card_number (string, required) — card number'),
            tr(lang, 'operation_type (string, обязательно) — тип операции (см. таблицу)', 'operation_type (string, required) — operation type (see table)'),
            tr(lang, 'amount (int, опционально) — сумма покупки в рублях', 'amount (int, optional) — purchase amount in rubles'),
            tr(lang, 'points (int, опционально) — количество баллов для операции', 'points (int, optional) — number of points for the operation'),
            tr(lang, 'order_id (string, опционально) — ID заказа в R-Keeper', 'order_id (string, optional) — R-Keeper order ID'),
            tr(lang, 'station_id (string, опционально) — ID кассовой станции', 'station_id (string, optional) — POS station ID'),
            tr(lang, 'cashier_id (string, опционально) — ID кассира', 'cashier_id (string, optional) — cashier ID'),
            tr(lang, 'external_id (string, опционально) — ключ идемпотентности', 'external_id (string, optional) — idempotency key'),
            tr(lang, 'restaurant_code (string, опционально) — код ресторана', 'restaurant_code (string, optional) — restaurant code'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Типы операций (operation_type)', 'Operation types (operation_type)'),
          items: [
            tr(lang, 'accrual — начисление кэшбэка за покупку', 'accrual — accrue cashback for a purchase'),
            tr(lang, 'payment — списание баллов как оплата', 'payment — deduct points as payment'),
            tr(lang, 'discount — применение скидки', 'discount — apply discount'),
            tr(lang, 'reverse_accrual — отмена начисления', 'reverse_accrual — reverse accrual'),
            tr(lang, 'reverse_payment — отмена списания', 'reverse_payment — reverse payment'),
            tr(lang, 'reverse_discount — отмена скидки', 'reverse_discount — reverse discount'),
          ],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — выполнено или дубликат', '200 — applied or duplicate'), tr(lang, '401 — неверный API-ключ', '401 — invalid API key'), tr(lang, '404 — карта не найдена', '404 — card not found'), tr(lang, '409 — недостаточно баллов для списания', '409 — insufficient points for payment')] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-transaction',
          value: `curl -X POST "${api.host}/rkeeper/transaction" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: rk_<API_KEY>" \\\n  -d '{\n    "card_number": "000042",\n    "operation_type": "accrual",\n    "amount": 1500,\n    "points": 75,\n    "order_id": "CHK-001",\n    "station_id": "POS1",\n    "external_id": "CHK-001-accrual"\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (успех)', 'Example response (success)'),
          key: 'rk-transaction-resp',
          value: `{\n  "success": true,\n  "status": "applied",\n  "duplicate": false,\n  "transaction_id": 77,\n  "external_id": "CHK-001-accrual",\n  "operation_type": "accrual",\n  "points_before": 425,\n  "points_after": 500,\n  "points_changed": 75,\n  "new_balance": 500\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (дубликат)', 'Example response (duplicate)'),
          key: 'rk-transaction-resp-dup',
          value: `{\n  "success": true,\n  "status": "duplicate",\n  "duplicate": true,\n  "transaction_id": 77,\n  "external_id": "CHK-001-accrual"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 401 — неверный ключ', '401 error — invalid key'),
          key: 'rk-transaction-err-401',
          value: `HTTP/1.1 401 Unauthorized\n\n{\n  "detail": "Invalid API key"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 404 — карта не найдена', '404 error — card not found'),
          key: 'rk-transaction-err-404',
          value: `HTTP/1.1 404 Not Found\n\n{\n  "detail": "Card not found"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 409 — недостаточно баллов', '409 error — insufficient points'),
          key: 'rk-transaction-err-409',
          value: `HTTP/1.1 409 Conflict\n\n{\n  "detail": "Insufficient balance: requested 500, available 120"\n}`,
        },
      ],
    },
    {
      id: 'rkeeper-balance',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'JSON API', 'JSON API'),
      navSubgroupOrder: 20,
      navOrder: 30,
      navLabel: tr(lang, 'Баланс карты', 'Card balance'),
      title: 'POST /rkeeper/balance',
      blocks: [
        { type: 'text', value: tr(lang, 'Быстрый запрос баланса без полных данных карты.', 'Quick balance query without full card data.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['X-API-Key: rk_<API_KEY>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            tr(lang, 'card_number (string, обязательно)', 'card_number (string, required)'),
            tr(lang, 'restaurant_code (string, опционально)', 'restaurant_code (string, optional)'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-balance',
          value: `curl -X POST "${api.host}/rkeeper/balance" \\\n  -H "Content-Type: application/json" \\\n  -H "X-API-Key: rk_<API_KEY>" \\\n  -d '{"card_number": "000042"}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'rk-balance-resp',
          value: `{\n  "success": true,\n  "card_number": "000042",\n  "balance": 500,\n  "available_for_payment": 500\n}`,
        },
      ],
    },
    {
      id: 'rkeeper-transactions-list',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'JSON API', 'JSON API'),
      navSubgroupOrder: 20,
      navOrder: 40,
      navLabel: tr(lang, 'История транзакций', 'Transaction history'),
      title: 'GET /rkeeper/transactions/organization/{org_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает список транзакций R-Keeper для карты с пагинацией.', 'Returns the list of R-Keeper transactions for a card with pagination.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Параметры запроса', 'Query params'), items: ['limit (int, default 50)', 'offset (int, default 0)'] },
        {
          type: 'code',
          title: 'curl',
          key: 'rk-tx-list',
          value: `curl -X GET "${api.host}/rkeeper/transactions/organization/<ORG_UUID>?limit=20&offset=0" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'rkeeper-farcards-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'FarCards (XML)', 'FarCards (XML)'),
      navSubgroupOrder: 30,
      navOrder: 0,
      navLabel: tr(lang, 'Протокол FarCards', 'FarCards protocol'),
      title: tr(lang, 'R-Keeper — протокол FarCards', 'R-Keeper — FarCards protocol'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'FarCards — стандартный XML-протокол R-Keeper для интеграции с внешними системами лояльности. R-Keeper автоматически вызывает эти эндпоинты при операциях на кассе. Все запросы: Content-Type: text/xml; ответы: XML.',
            'FarCards is R-Keeper\'s standard XML protocol for integrating with external loyalty systems. R-Keeper automatically calls these endpoints during POS operations. All requests use Content-Type: text/xml; responses are XML.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'FarCards эндпоинты', 'FarCards endpoints'),
          items: [
            `POST ${api.host}/rkeeper/getcardinfoex`,
            `POST ${api.host}/rkeeper/transactionsex`,
            `POST ${api.host}/rkeeper/findemail`,
            `POST ${api.host}/rkeeper/getcardimageex`,
            `POST ${api.host}/rkeeper/licenseinfo`,
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Таблица Kind → operation_type', 'Kind → operation_type table'),
          items: [
            tr(lang, 'Kind=2, Summa≥0 → accrual (начисление кэшбэка)', 'Kind=2, Summa≥0 → accrual (cashback accrual)'),
            tr(lang, 'Kind=2, Summa<0 → reverse_accrual (отмена начисления)', 'Kind=2, Summa<0 → reverse_accrual (reverse accrual)'),
            tr(lang, 'Kind=0, Summa≤0 → payment (списание баллов)', 'Kind=0, Summa≤0 → payment (points payment)'),
            tr(lang, 'Kind=0, Summa>0 → reverse_payment (отмена списания)', 'Kind=0, Summa>0 → reverse_payment (reverse payment)'),
            tr(lang, 'Kind=1, Summa≤0 → discount (применение скидки)', 'Kind=1, Summa≤0 → discount (apply discount)'),
            tr(lang, 'Kind=1, Summa>0 → reverse_discount (отмена скидки)', 'Kind=1, Summa>0 → reverse_discount (reverse discount)'),
          ],
        },
      ],
    },
    {
      id: 'rkeeper-farcards-cardinfo',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'FarCards (XML)', 'FarCards (XML)'),
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: 'getcardinfoex',
      title: 'POST /rkeeper/getcardinfoex',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает данные карты и баланс. Вызывается R-Keeper автоматически при поднесении карты к кассе.', 'Returns card data and balance. Called automatically by R-Keeper when a card is presented at the POS.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Content-Type: text/xml', 'Authorization: Basic base64(:<API_KEY>)'] },
        {
          type: 'code',
          title: tr(lang, 'XML запрос', 'XML request'),
          key: 'rk-getcardinfo-req',
          value: `<?xml version="1.0" encoding="utf-8"?>\n<Root>\n  <QRY Card="000042" Restaurant="REST1" UnitNo="POS1"/>\n</Root>`,
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ (успех)', 'XML response (success)'),
          key: 'rk-getcardinfo-resp',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root>\n  <GetCardInfoEx\n    CardCode="000042"\n    Account="000042"\n    Deleted="0" Locked="0" Seize="0"\n    Discount="0"\n    Bonus="5"\n    Summa="500"\n    DiscLimit="500"\n    Holder="Иван Иванов"\n    Result="0">\n    <OutBuf OutKind="4"><ident_info/></OutBuf>\n  </GetCardInfoEx>\n</Root>`,
        },
        {
          type: 'list',
          title: tr(lang, 'Поля ответа', 'Response fields'),
          items: [
            tr(lang, 'Bonus — процент кэшбэка', 'Bonus — cashback percent'),
            tr(lang, 'Summa — текущий баланс баллов', 'Summa — current points balance'),
            tr(lang, 'DiscLimit — доступно к списанию', 'DiscLimit — available for spending'),
            tr(lang, 'Discount — процент скидки', 'Discount — discount percent'),
            tr(lang, 'Holder — имя владельца карты', 'Holder — card holder name'),
            tr(lang, 'Result=0 — успех, Result=1 — ошибка', 'Result=0 — success, Result=1 — error'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ (карта не найдена)', 'XML response (card not found)'),
          key: 'rk-getcardinfo-resp-err',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root>\n  <GetCardInfoEx\n    CardCode=""\n    Account=""\n    Deleted="0" Locked="0" Seize="0"\n    Discount="0" Bonus="0" Summa="0"\n    DiscLimit="0" Holder=""\n    Result="1" ErrText="Card not found"/>\n</Root>`,
        },
      ],
    },
    {
      id: 'rkeeper-farcards-tx',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'FarCards (XML)', 'FarCards (XML)'),
      navSubgroupOrder: 30,
      navOrder: 20,
      navLabel: 'transactionsex',
      title: 'POST /rkeeper/transactionsex',
      blocks: [
        { type: 'text', value: tr(lang, 'Проводит транзакцию (начисление, списание или скидка). Вызывается R-Keeper при закрытии чека. Идемпотентен по RKCheck+Kind.', 'Processes a transaction (accrual, payment or discount). Called by R-Keeper when a check is closed. Idempotent by RKCheck+Kind.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Content-Type: text/xml', 'Authorization: Basic base64(:<API_KEY>)'] },
        {
          type: 'code',
          title: tr(lang, 'XML запрос', 'XML request'),
          key: 'rk-tx-req',
          value: `<?xml version="1.0" encoding="utf-8"?>\n<Root>\n  <INPBUF>\n    <CHECK restaurantcode="REST1" stationcode="POS1"/>\n  </INPBUF>\n  <TransactionsEx\n    Card="000042"\n    Kind="2"\n    Summa="75"\n    RKCheck="CHK-001"\n    RKUnit="POS1"\n    PersonID="emp42"\n    RKDate="20240318"/>\n</Root>`,
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ (успех)', 'XML response (success)'),
          key: 'rk-tx-resp',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root>\n  <TransactionsEx Result="0"/>\n  <OutBuf OutKind="1">\n    <TRRESPONSE error_code="0" err_text="">\n      <TRANSACTION\n        ext_id="rk:CHK-001:0:2:pos"\n        num="rk:CHK-001:0:2:pos"\n        cardcode="000042"\n        value="75"/>\n    </TRRESPONSE>\n  </OutBuf>\n</Root>`,
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ (ошибка — недостаточно баллов)', 'XML response (error — insufficient points)'),
          key: 'rk-tx-resp-err',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root>\n  <TransactionsEx Result="2"/>\n  <OutBuf OutKind="1">\n    <TRRESPONSE error_code="2" err_text="Insufficient balance">\n    </TRRESPONSE>\n  </OutBuf>\n</Root>`,
        },
      ],
    },
    {
      id: 'rkeeper-farcards-findemail',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'FarCards (XML)', 'FarCards (XML)'),
      navSubgroupOrder: 30,
      navOrder: 30,
      navLabel: 'findemail',
      title: 'POST /rkeeper/findemail',
      blocks: [
        { type: 'text', value: tr(lang, 'Поиск карты клиента по email. R-Keeper вызывает при идентификации клиента по email.', 'Search for a customer card by email. R-Keeper calls this when identifying a customer by email.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Content-Type: text/xml', 'Authorization: Basic base64(:<API_KEY>)'] },
        {
          type: 'code',
          title: tr(lang, 'XML запрос', 'XML request'),
          key: 'rk-findemail-req',
          value: `<?xml version="1.0" encoding="utf-8"?>\n<Root><QRY Email="client@example.com"/></Root>`,
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ (успех)', 'XML response (success)'),
          key: 'rk-findemail-resp',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root>\n  <FindEmail Result="0" Account="000042" CardCode="000042" Name="Иван Иванов"/>\n</Root>`,
        },
      ],
    },
    {
      id: 'rkeeper-farcards-license',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'R-Keeper',
      navGroupOrder: 20,
      navSubgroup: tr(lang, 'FarCards (XML)', 'FarCards (XML)'),
      navSubgroupOrder: 30,
      navOrder: 40,
      navLabel: 'licenseinfo',
      title: 'POST /rkeeper/licenseinfo',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Проверка лицензии. R-Keeper вызывает при запуске и периодически. Если возвращает Result=1 — R-Keeper блокирует операции лояльности. Всегда возвращает Result=0 при активной интеграции.',
            'License check. R-Keeper calls this on startup and periodically. If Result=1 is returned — R-Keeper blocks loyalty operations. Always returns Result=0 for an active integration.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Content-Type: text/xml', 'Authorization: Basic base64(:<API_KEY>)'] },
        {
          type: 'code',
          title: tr(lang, 'XML запрос', 'XML request'),
          key: 'rk-licenseinfo-req',
          value: `<?xml version="1.0" encoding="utf-8"?>\n<Root><QRY Restaurant="REST1" Status="1"/></Root>`,
        },
        {
          type: 'code',
          title: tr(lang, 'XML ответ', 'XML response'),
          key: 'rk-licenseinfo-resp',
          value: `<?xml version='1.0' encoding='utf-8'?>\n<Root><LicenseInfo Result="0"/></Root>`,
        },
      ],
    },
  ];
}
